export default {
  ITEM_TYPE_HAKKA: '客家電視台諮議委員會',
  ITEM_TYPE_NEWS: '新聞暨節目自律委員會',
  ITEM_TYPE_NEWS_SCORE: '新聞評量委員會',
  ITEM_TYPE_MANUFACTURE_GUIDELINE: '製播準則',
  ITEM_TYPE_PUBLIC_ACCOUNTABILITY: '公共問責',

  監督機制委員職稱_召集人: '召集人',
  監督機制委員職稱_副召集人: '副召集人',
  監督機制委員職稱_主任委員: '主任委員',
  監督機制委員職稱_委員: '委員',
}